










































import {Vue, Component, VModel} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import AddressDTO from "@/dto/AddressDTO";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import {ifValid, processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {CreateInvoiceContactPayload} from "@/components/payroll/business/services/ServiceDTO";
import {v4 as uuidv4} from "uuid";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";

@Component({
	components: {PortalAddress, PortalInput, RightSideBar}
})
export default class ContactCreationSlider extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean
	private search: string | null = null

	private id = uuidv4().toString()

	private name: string | null = null
	private email: string | null = null
	private address: AddressDTO = new AddressDTO()

	public saveContact(): void {
		ifValid(this, () => {
			Application.startLoading()
			ServiceLogOrchestrator.createContact(
				new CreateInvoiceContactPayload(
					{
						name: this.name,
						email: this.email,
						address: this.address,
						createdBy: this.$wss.getCurrent.id
					}
				)
			).then(
				(contact) => {
					Application.stopLoading();
					this.$emit('created', contact.data);
					this.$emit("input", false);
				},
				err => processError(err, this)
			)
		})
	}

}
